export default __webpack_public_path__ + "static/desktop-chart-01-d-11c8e3c0b14702f346cfe53f533c3f56.svg";